// Turns free text into holdings. Accepts "VTI 120, NVDA 90", one per line,
// "120 VTI", "VTI x 120", "VTI: 120", "VTI,120". Duplicates are merged.

const TICKER_RE = /^[A-Z][A-Z0-9.&-]{0,11}$/;

export const SAMPLE_HOLDINGS_TEXT = 'VTI 120, NVDA 90, TTWO 60, AAPL 60, RELIANCE.NS 400';

function looksNumeric(s) {
  return /^[\d.,]+$/.test(s);
}

export function parseHoldings(text) {
  const holdings = [];
  const errors = [];

  const chunks = String(text || '')
    .split(/[\n;,]+/)
    .map((s) => s.trim())
    .filter(Boolean);

  // Re-pair "VTI" followed by "120" when a comma separated them.
  const merged = [];
  for (let i = 0; i < chunks.length; i += 1) {
    const cur = chunks[i];
    const next = chunks[i + 1];
    if (!/\s/.test(cur) && !looksNumeric(cur) && next && looksNumeric(next)) {
      merged.push(`${cur} ${next}`);
      i += 1;
    } else {
      merged.push(cur);
    }
  }

  merged.forEach((chunk) => {
    const parts = chunk
      .replace(/\s+[x×]\s+/gi, ' ')
      .replace(/[:@]/g, ' ')
      .split(/\s+/)
      .filter(Boolean);
    if (parts.length < 2) {
      errors.push(`"${chunk}" needs a ticker and a share count`);
      return;
    }
    let ticker;
    let qty;
    if (looksNumeric(parts[0])) {
      qty = parts[0];
      ticker = parts[1];
    } else {
      ticker = parts[0];
      qty = parts[1];
    }
    ticker = ticker.toUpperCase();
    const n = parseFloat(String(qty).replace(/,/g, ''));
    if (!TICKER_RE.test(ticker)) {
      errors.push(`"${ticker}" doesn't look like a ticker`);
      return;
    }
    if (!(n > 0)) {
      errors.push(`"${chunk}" has no valid share count`);
      return;
    }
    const existing = holdings.find((h) => h.ticker === ticker);
    if (existing) existing.quantity += n;
    else holdings.push({ ticker, quantity: n });
  });

  return { holdings, errors };
}
